// extracted by mini-css-extract-plugin
module.exports = {"modal":"p_Y","modal__bg":"p_Z","modal__close":"p_0","modal__header":"p_1","modal__header__close":"p_2","modal__content":"p_3"};